import React from 'react';
import { Row, Toggle, Image } from '@thd-olt-component-react/core-ui';
import PropTypes from 'prop-types';
import { useConfigService } from '@thd-nucleus/experience-context';
import { generateImageSource } from '../../utils/generateImageSource';
import { clickEvents } from '../../utils/analytics';

const ProfileMarkAsHiredSection = ({ profile, updateHireStatus }) => {

  const isHiredEnabled = useConfigService('fs:isHiredEnabled');

  if (!profile.candidateContacted || !isHiredEnabled) {
    return null;
  }

  const handleToggle = () => {
    clickEvents.hireCandidate(
      profile.candidateId,
      `${profile.candidateHired ? 'not ' : ''}hired>profile`
    );
    updateHireStatus(profile);
  };

  return (
    <div className="p2p-profile-mark-as-hired__root">
      <Image
        alt="magnifying glass"
        className="p2p-profile-mark-as-hired__icon"
        src={generateImageSource('/images/v1/path-to-pro/search-stars-icon.svg')}
      />
      <div className="p2p-profile-mark-as-hired__main">
        <Row className="p2p-profile-mark-as-hired__description">
          <span className="p2p-profile-mark-as-hired__orange-text">We noticed you have viewed this candidate already. </span>
          <span>Marking this candidate as hired will help us improve your experience,
          and remove any redundant profiles in your search.
          </span>
        </Row>
        <Row className="p2p-profile-mark-as-hired__toggle-block">
          <span>
            Did you hire this candidate?
          </span>
          <span onClick={(e) => e.stopPropagation()} className="toggle">
            <Toggle
              onChange={handleToggle}
              checked={profile.candidateHired}
              label={profile.candidateHired ? 'Hired' : 'Not Hired'}
              id={`hired-${profile.candidateId}-profile`}
            />
          </span>
        </Row>
      </div>
    </div>
  );
};

ProfileMarkAsHiredSection.propTypes = {
  profile: PropTypes.shape({
    candidateHired: PropTypes.bool.isRequired,
    candidateId: PropTypes.number.isRequired
  }).isRequired,
  updateHireStatus: PropTypes.func.isRequired
};

export default ProfileMarkAsHiredSection;
